<template>
  <fieldset :class="BLOCK_SELECTOR">
    <label
      v-for="tab in tabs"
      :key="tab.key"
      :class="[
        `${BLOCK_SELECTOR}__tab`,
        `${BLOCK_SELECTOR}__tab--${tab.key}`,
        { [`${BLOCK_SELECTOR}__tab--selected`]: value === tab.key },
      ]"
      @keydown.enter="handleTabChange(tab.key)"
      @keydown.space.prevent="handleTabChange(tab.key)"
    >
      <input
        :id="`tab-${name}-${String(tab.key)}`"
        :class="`${BLOCK_SELECTOR}__radio`"
        :value="tab.key"
        :checked="value === tab.key"
        :name="name"
        type="radio"
        @change="handleTabChange(tab.key)"
      />

      {{ tab.label }}
    </label>
  </fieldset>
</template>

<script>
export default {
  name: 'ConfiguratorEditorTabs',
  emits: ['input'],
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      default: 'tabs',
    },
  },
  data() {
    return {
      BLOCK_SELECTOR: 'configurator-editor-tabs',
    };
  },
  methods: {
    handleTabChange(tabKey) {
      if (tabKey === 'content') {
        globalThis.dispatchEvent(
          new CustomEvent('lgf.configurator.stepVisual')
        );
        globalThis.dispatchEvent(
          new CustomEvent('lgf.configurator.stepContent')
        );
      }
      this.$emit('input', tabKey);
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-editor-tabs {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(max-content, 1fr);
  border: none;
  margin: 0;
  padding: 0.3125rem 0.625rem 0;
  width: 100%;
  gap: 0.3125rem;
  justify-content: center;

  @include breakpoint($breakpoint-l) {
    gap: 0.75rem;
  }

  &__tab {
    min-width: 0;
    text-align: center;
    padding: 0.8125rem 1.5rem;
    margin: 0;
    border-radius: 0.75rem;
    background-color: $color-grey-wild-sand;
    text-transform: uppercase;
    color: $color-blue-persian;
    cursor: pointer;
    font-family: $font-big-shoulders;
    font-weight: 900;
    border: solid 1px $color-blue-persian;
    white-space: nowrap;

    &--selected {
      background-color: $color-blue-persian;
      color: $color-white;
      box-shadow: 0 0 0.75rem 0 rgba(0, 0, 0, 0.12);
    }

    &--product {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.1875rem;

      &::before {
        @extend %icon;
        @extend %icon--tiny-cup;

        display: inline;
        font-size: 1.25rem;
      }
    }

    &--content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.1875rem;

      &::before {
        @extend %icon;
        @extend %icon--customization;

        display: inline;
        font-size: 1.25rem;
      }
    }

    @include breakpoint($breakpoint-l) {
      max-width: 10.5625rem;
    }
  }

  &__radio {
    appearance: none;
  }
}
</style>
